<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div class="loading" v-if="processando">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
      </div>
      <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalMudarMotorista">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Mudar Motorista</h4>
            </div> 
            <div class="modal-body">
              <div class="col-md-12">                  
                <div class="row">
                  <div class="form-group col-sm-12 col-md-12">
                    <label>Motorista:</label><br>
                    <input id="motoristaId" type="hidden" class="form-control" v-model="motoristaId">
                    <buscar-motorista  id="motoristaNome" placeholder="Selecione um motorista.." v-model="motoristaNome" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :on-select="setarMotorista" :on-blur="verificarMotorista" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="mudarMotorista">Gravar</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalMudarMotorista = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalDividirTempo">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Dividir Tempo</h4>
            </div> 
            <div class="modal-body">
              <div class="col-md-12">                  
                <div class="row">
                  
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="dividirTempo">Gravar</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalDividirTempo = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalDividirTempo">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Mudar Motivo</h4>
            </div> 
            <div class="modal-body">
              <div class="col-md-12">                  
                <div class="row">
                  
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="dividirTempo">Gravar</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalDividirTempo = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="row row-margin">
            <div class="col-sm-12 col-md-12">
              <h4>Editar Jornada</h4>
            </div>
          </div>
          <div class="row row-margin">
            <div class="col-md-12">
              <input id="botaoSalvar" class="btn btn-success" type="submit" value="Recalcular e Salvar" v-on:click="salvar">
              <router-link class="btn btn-warning" to="/gestaoJornada">
                <span class="glyphicon glyphicon-back"></span> Fechar
              </router-link>
            </div>
          </div>
          <br>
          <div class="row row-margin">
            <div class="col-md-5">
              <strong>Data: </strong>De: {{jornada.dataHoraInicial}} até {{jornada.dataHoraFinal}}
            </div>
            <div class="col-md-3">
              <strong>Veículo: </strong> {{jornada.veiculoDescricao}}
            </div>
            <div class="col-md-3">
              <strong>Motorista: </strong> {{jornada.motoristaNome}}<br>
              <span v-on:click="showModalMudarMotorista = true">Mudar motorista</span>              
            </div>
          </div>
          <br>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>PERIODO</th>
                <th>DURAÇÃO</th>
                <th></th>
                <th>MOTIVO</th>
                <th>TIPO</th>
                <th>OBSERVAÇÃO</th>
                <th></th>
              </tr>
            </thead>
            <tbody v-for="(grid, i) in jornadaItens" >
              
              <tr>
                <td><small>{{grid.dataHoraInicio}}<br>{{grid.dataHoraFinal}}</small></td>
                <td><small>{{grid.dataHoraDuracao}}</small></td>
                <td><small>{{grid.statusVeiculo}}</small></td>
                <td><small>{{grid.motivo}}</small></td>
                <td><small>{{grid.tipoMotivo}}</small></td> 
                <!-- <td>{{grid.movimentoSecundario}}</td> -->
                <td><small>{{grid.observacao}}</small></td>
                <!-- <td>
                  <template v-if="grid.statusVeiculo === 'VEICULO PARADO'">
                    <a onclick="verNoMapa('0.0;', '0.0;')" href="#">
                      <img src="/static/images/ponto.png" />
                    </a>
                  </template>
                </td> -->
                <td>
                  <template v-if="grid.statusVeiculo === 'VEICULO PARADO'">
                    <a onclick="dividirJornada(500209)" href="#">
                      <img src="/static/images/editar.png" />
                    </a>
                  </template>
                </td>
                <!-- <td>{{latitude}}</td>
                <td>{{longitude}}</td>
                <td>{{icone}}</td>
                <td>{{kmRodados}}</td>
                <td>{{velocidadeMaxima}}</td>
                <td>{{velocidadeMedia}}</td>
                <td>{{alerta}}</td>
                <td>{{error}}</td>
                <td>{{automatico}}</td>
                <td>{{mudouDia}}</td> -->
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-md-9 text-center"></div>
            <div class="col-md-3 text-center">
              <strong>TOTAIS</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md-11 text-right">
              Tempo em Abastecimento: <br/>
              Tempo em Adicional Noturno: <br/>
              Tempo em Alimentação: <br/>
              Tempo em Carga e Descarga: <br/>
              Tempo em Descanso de Dirção: <br/>
              Tempo em Direção: <br/>
              Tempo em Fiscalização: <br/>
              Tempo em Hora Extra Normal 1:<br/>
              Tempo em Hora Extra Normal 2: <br/>
              Tempo em Hora Extra Noturna 1:<br/>
              Tempo em Hora Extra Noturna 2: <br/>
              Tempo em Hora Indenizada: <br/>
              Tempo em Jornada: <br/>
              Tempo em Manutenção: <br/>
            </div>
            <div class="col-md-1">
              <strong> {{jornada.tempoAbastecimento}} </strong><br/>
              <strong> {{jornada.tempoAdicionalNoturno}} </strong><br/>
              <strong> {{jornada.tempoAlimentacao}} </strong><br/>
              <strong> {{jornada.tempoCargaDescarga}} </strong><br/>
              <strong> {{jornada.tempoDescansoDirecao}} </strong><br/>
              <strong> {{jornada.tempoDirecao}} </strong><br/>
              <strong> {{jornada.tempoFiscalizacao}} </strong><br/>
              <strong> {{jornada.tempoHoraExtraNormal1}} </strong><br/>
              <strong> {{jornada.tempoHoraExtraNormal2}} </strong><br/>
              <strong> {{jornada.tempoHoraExtraNoturna1}} </strong><br/>
              <strong> {{jornada.tempoHoraExtraNoturna2}} </strong><br/>
              <strong> {{jornada.tempoHoraIndenizada}} </strong><br/>
              <strong> {{jornada.tempoJornada}} </strong><br/>
              <strong> {{jornada.tempoManutencao}} </strong><br/>
            </div>
          </div>

				</div>
      </div>
    </div>
	</div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      processando: false,
      showModalMudarMotorista: false,
      showModalDividirTempo: false,
      jornada: [],
      jornadaItens: [],
      motoristaId: '0',
      motoristaNome: ''
    }
  },
  created: function () {
    this.buscar()
    this.buscarItens()
  },
  mounted: function () {
    $('.pula').keypress(function (e) {
      var tecla = (e.keyCode ? e.keyCode : e.which)
      if (tecla === 13) {
        let campo = $('.pula')
        let indice = campo.index(this)
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus()
        }
        if (campo[indice + 1] != null) {
          let proximo = campo[indice + 1]
          proximo.focus()
        }
        e.preventDefault(e)
        return false
      }
    })
  },
  methods: {
    buscar: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/gestaoJornadas/editar?id=' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.jornada = dados
      })
    },
    buscarItens: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/gestaoJornadas/itens?id=' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.jornadaItens = dados
      })
    },
    mudarMotorista: function () {
      var self = this
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      self.processando = true
      var url = '/api/gestaoJornadas/mudarMotorista?jornadaId=' + this.$route.params.id + '&motoristaId=' + self.motoristaId
      axios.get(url, config)
      .then(function (response) {
        console.log(response)
        if (response.data === 'OK') {
          self.processando = false
          self.showModalMudarMotorista = false
          self.buscar()
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    setarMotorista: function (motorista) {
      this.motoristaId = motorista.id
      this.motoristaNome = motorista.nome
      $(this.$el).find('#motoristaNome').val(motorista.nome)
    },
    verificarMotorista: function () {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.motoristaId = 0
        this.motoristaNome = ''
        $(this.$el).find('#motoristaId').val(0)
        $(this.$el).find('#motoristaNome').val('')
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.motoristaId = 0
        this.motoristaNome = ''
        $(this.$el).find('#motoristaId').val(0)
        $(this.$el).find('#motoristaNome').val('')
      }
    },
    showDividirTempo: function (jornadaId) {
      var self = this
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      self.processando = true
      var url = '/api/gestaoJornadas/buscarJornadaItem&id=' + jornadaId
      axios.get(url, config)
      .then(function (response) {
        console.log(response)
        self.processando = false
        self.showModalDividirTempo = true
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    gravarDividirTempo: function () {
      var self = this
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      self.processando = true
      var url = '/api/gestaoJornadas/gravarDivisaoGestaoJornadaItem?id=' + this.$route.params.id + '&dataHoraInicio=' + self.divisao.dataHoraInicio + '&dataHoraFinal=' + self.divisao.dataHoraFinal + '&dataHoraDuracao=' + self.divisao.dataHoraDuracao + '&motivo=' + self.divisao.motivo + '&observacao=' + self.divisao.observacao + '&status=' + self.divisao.status
      axios.get(url, config)
      .then(function (response) {
        console.log(response)
        if (response.data === 'OK') {
          self.processando = false
          self.buscar()
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    salvar: function () {
      var self = this
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      self.processando = true
      var url = '/api/gestaoJornadas/salvar'
      axios.post(url, JSON.stringify(self.jornada), config)
      .then(function (response) {
        console.log(response)
        if (response.data === 'OK') {
          self.processando = false
          self.$router.replace('/gestaoJornada')
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/jornadasconvencoes/GestaoJornadasConvencaoNovo.vue